import * as React from 'react';
import { isMd } from 'src/utils/responsiveHelpers';
import scrollToComponent from 'react-scroll-to-component';
import { disableScroll, enableScroll } from 'src/utils/documentInteraction';

import ProductModel, { IPartModel } from 'src/model/product.model';

import PartCard from 'src/components/common/PartCard';
import PartCardLoading from 'src/components/common/PartCardLoading';
import ModelDiagram from 'src/components/ModelDiagram';
import PartDetailsModelDesktop from 'src/components/PartDetailsModel/PartDetailsModelDesktop';
import PartDetailsModelMobile from 'src/components/PartDetailsModel/PartDetailsModelMobile';

import defaultImage from 'src/assets/defaultImage';
import { breakpoints } from '../../utils/responsiveHelpers';

import './PartsCatalog.scss';

import DiagramModel from 'src/model/diagram.model';
import ProductDetailsModel from 'src/model/productdetails.model';
import Loader from '../common/Loader';
const Stickyfill = require('stickyfilljs');

export default class ProductCatalog extends React.Component<
  IPartsCatalogProps,
  IPartsCatalogState
> {
  private activePartRef: any;
  private activePartCardRef: any;
  private catalogRef: any;

  constructor(props: IPartsCatalogProps) {
    super(props);

    this.state = {
      isMobile: this.isMobile(),
      isModalOpened: false,
      partsRendered: false
    };

    this.activePartRef = null;
    this.activePartCardRef = null;
    this.catalogRef = null;
  }

  private renderContent = () => {
    if (this.props.loading) {
      return (
        <div className="rp-parts-catalog-grid loading">
          {this.renderLoadingElements()}
        </div>
      );
    } else if (this.props.parts.length !== 0) {
      const activeClass = this.props.useActiveDiagram
        ? 'diagram-active'
        : 'diagram-hidden';
      return (
        <div className={`rp-parts-catalog--parts-container ${activeClass}`}>
          <div
            className="rp-parts-catalog--part-detail"
            ref={(ref: HTMLElement) => {
              this.activePartRef = ref;
            }}
          >
            {this.renderActivePart()}
          </div>
          {(this.props.useActiveDiagram || this.props.textFilter) &&
            !this.state.partsRendered && (
            <div className="rp-parts-catalog-loader">
                <div className="loader loader-1" />
            </div>
          )}
          <div
          className={`rp-parts-catalog-grid ${
            (this.props.useActiveDiagram || this.props.textFilter) &&
            !this.state.partsRendered
              ? "disabled-ui"
              : ""
          }`}
          ref={ref => (this.catalogRef = ref)}
        > 

            {this.props.useActiveDiagram || this.props.textFilter ? (
              <>
                {this.renderFeaturedParts()}
                {this.renderParts()}
              </>
            ) : (
              this.renderCommonParts()
            )}
          </div>

        </div>
      );
    } else {
      return this.renderEmptyList();
    }
  };

  private renderFeaturedParts = () => {
    const { featuredProducts } = this.props;
    return featuredProducts.map((item, index) => {
      let productImg = '';
      if (item.imageUrls == null) {
        productImg = defaultImage;
      } else {
        productImg =
          item.imageUrls &&
          item.imageUrls instanceof Array &&
          item.imageUrls.length !== 0
            ? item.imageUrls[0]
            : defaultImage;
      }

      const onPartSelected = (part: ProductModel) => {
        const offsetValue = this.state.isMobile ? -48 : -80;
        const activePartScroll = {
          offset: offsetValue,
          align: 'top',
          duration: 500
        };
        this.props.setActivePart(part);
        scrollToComponent(this.activePartRef, activePartScroll);
      };

      return (
        <div className={`rp-parts-catalog-grid--product`} key={index}>
          <PartCard
            ref={(ref: any) => {
              if (item === this.props.activePart) {
                this.activePartCardRef = ref;
              }
            }}
            showGoToDiagram={this.props.activeDiagram ? false : true}
            goToDiagram={this.props.goToDiagram}
            showOnlyMSRP={this.props.onlyMsrp}
            isLoggedIn={this.props.isLoggedIn}
            image={productImg}
            part={item}
            dataOnVisible={true}
            partUpdate={(partId: string, manufacturerCode: string) => {
              this.props.updateFeaturedProduct(partId, manufacturerCode);
            }}
            setActivePart={() => {
              onPartSelected(item);
            }}
            handleToggleFavorite={this.props.handleToggleFavorite}
            textFilter={this.props.textFilter}
            position={index}
            modelDiagramProductClick={this.props.modelDiagramProductClick}
          />
        </div>
      );
    });
  };

  private renderCommonParts = () => {
    const { commonParts } = this.props;
    return commonParts.map((item, index) => {
      let productImg = '';
      if (item.imageUrls == null) {
        productImg = defaultImage;
      } else {
        productImg =
          item.imageUrls &&
          item.imageUrls instanceof Array &&
          item.imageUrls.length !== 0
            ? item.imageUrls[0]
            : defaultImage;
      }

      const onPartSelected = (part: ProductModel) => {
        const offsetValue = this.state.isMobile ? -48 : -80;
        const activePartScroll = {
          offset: offsetValue,
          align: 'top',
          duration: 500
        };
        this.props.setActivePart(part);
        scrollToComponent(this.activePartRef, activePartScroll);
      };

      return (
        <div className={`rp-parts-catalog-grid--product`} key={index}>
          <PartCard
            ref={(ref: any) => {
              if (item === this.props.activePart) {
                this.activePartCardRef = ref;
              }
            }}
            showGoToDiagram={this.props.activeDiagram ? false : true}
            goToDiagram={this.props.goToDiagram}
            showOnlyMSRP={this.props.onlyMsrp}
            isLoggedIn={this.props.isLoggedIn}
            image={productImg}
            part={item}
            dataOnVisible={true}
            partUpdate={() => null}
            setActivePart={() => {
              onPartSelected(item);
            }}
            handleToggleFavorite={this.props.handleToggleFavorite}
            textFilter={this.props.textFilter}
            position={index}
            modelDiagramProductClick={this.props.modelDiagramProductClick}
          />
        </div>
      );
    });
  };

  private renderParts = () => {
    const { parts } = this.props;
    return parts.map((item, index) => {
      let productImg = '';
      if (item.imageUrls == null) {
        productImg = defaultImage;
      } else {
        productImg =
          item.imageUrls &&
          item.imageUrls instanceof Array &&
          item.imageUrls.length !== 0
            ? item.imageUrls[0]
            : defaultImage;
      }

      const onPartSelected = (part: ProductModel) => {
        const offsetValue = this.state.isMobile ? -48 : -80;
        const activePartScroll = {
          offset: offsetValue,
          align: 'top',
          duration: 500
        };
        this.props.setActivePart(part);
        scrollToComponent(this.activePartRef, activePartScroll);
      };

      return (
        <div className={`rp-parts-catalog-grid--product`} key={index}>
          <PartCard
            ref={(ref: any) => {
              if (item === this.props.activePart) {
                this.activePartCardRef = ref;
              }
            }}
            showGoToDiagram={this.props.activeDiagram ? false : true}
            goToDiagram={this.props.goToDiagram}
            showOnlyMSRP={this.props.onlyMsrp}
            isLoggedIn={this.props.isLoggedIn}
            image={productImg}
            part={item}
            dataOnVisible={true}
            partUpdate={(
              partId: string,
              manufacturerCode: string,
              ownerDiagram: number
            ) => {
              this.updatePart(partId, manufacturerCode, ownerDiagram);
            }}
            setActivePart={() => {
              onPartSelected(item);
            }}
            handleToggleFavorite={this.props.handleToggleFavorite}
            textFilter={this.props.textFilter}
            position={index}
            modelDiagramProductClick={this.props.modelDiagramProductClick}
          />
        </div>
      );
    });
  };

  private renderEmptyList = () => {
    return (
      <div
        className="rp-parts-catalog-grid--no-products"
        ref={ref => (this.catalogRef = ref)}
      >
        <i className="rpds-error" />
        <p className="empty-message">{this.props.emptyMessage}</p>
      </div>
    );
  };

  private renderLoadingElements = () => {
    const items = [];
    let i = 0;
    while (i < 6) {
      items.push(
        <div key={i} className="rp-parts-catalog-grid--loading-element">
          <PartCardLoading />
        </div>
      );
      i++;
    }
    return items;
  };

  private renderActiveDiagram = () => {
    if (this.props.useActiveDiagram) {
      const modalOpenedClass = this.state.isModalOpened
        ? 'modal-is-opened'
        : 'modal-is-closed';
      return (
        <div className={`rp-parts-catalog--active-diagram ${modalOpenedClass}`}>
          <div className="component-container">
            <ModelDiagram
              onPrintAll={this.props.diagrams}
              modelDiagram={this.props.activeDiagram}
              onDiagramOpened={this.handleModalStatus}
            />
          </div>
        </div>
      );
    } else {
      return <React.Fragment />;
    }
  };

  private renderActivePart = () => {
    if (this.props.activePart !== null) {
      const partDetails = this.props.activePart.productDetails;
      if (partDetails != null) {
        const patchedDetails = this.patchProductDetails({
          ...partDetails,
          replacedPart: this.props.activePart.replacedPart,
          replacedMfc: this.props.activePart.replacedMfc
        });

        return this.state.isMobile ? (
          <div className={'rp-parts-catalog--active-part'}>
            <div className="part-details">
              <PartDetailsModelMobile
                part={patchedDetails}
                partAddress={partDetails.address}
                ref={ref => {
                  this.activePartRef = ref;
                }}
                scrollToTop={() => {
                  const activePartScroll = {
                    offset: -48,
                    align: 'top',
                    duration: 500
                  };
                  scrollToComponent(this.activePartRef, activePartScroll);
                }}
                handleClose={() => {
                  this.props.setActivePart(null);
                  scrollToComponent(this.activePartCardRef);
                }}
              />
            </div>
          </div>
        ) : (
          <div className={'rp-parts-catalog--active-part'}>
            <div className="part-details">
              <PartDetailsModelDesktop
                part={patchedDetails}
                partAddress={partDetails.address}
                ref={ref => {
                  this.activePartRef = ref;
                }}
                scrollToTop={() => {
                  const activePartScroll = {
                    offset: -80,
                    align: 'top',
                    duration: 500
                  };
                  scrollToComponent(this.activePartRef, activePartScroll);
                }}
                handleClose={() => {
                  this.props.setActivePart(null);
                  scrollToComponent(this.activePartCardRef);
                }}
              />
            </div>
          </div>
        );
      } else {
        return <React.Fragment />;
      }
    } else {
      return <React.Fragment />;
    }
  };

  private updatePart = (
    partId: string,
    manufacturerCode: string,
    ownerDiagram: number
  ) => {
    this.props.updateProductMethod(partId, manufacturerCode, ownerDiagram);
  }; 

private arePartsReady = (list: ProductModel[]) =>
  list.length === 0 ? true : list.every(p => p.productDetailsState !== 'pending');



  private patchProductDetails = (details: ProductDetailsModel): IPartModel => {
    const patchedDetails = {
      ...details
    };
    const emptyDetails = new ProductDetailsModel();
    // Change null values to data type empty value
    Object.keys(patchedDetails).map((key: any) => {
      if (patchedDetails[key] === null) {
        patchedDetails[key] = emptyDetails[key];
      }
    });

    const supply =
      this.props.activePart !== null
        ? patchedDetails.warehouses.findIndex(
            warehouse => warehouse.description === 'Supplier Quantity'
          )
        : -1;

    const wDefault =
      this.props.activePart !== null
        ? patchedDetails.warehouses.findIndex(
            warehouse => warehouse.default === true
          )
        : -1;

    return {
      images: patchedDetails.images,
      name: patchedDetails.name,
      productNumber: patchedDetails.productNumber,
      description: patchedDetails.description,
      price: patchedDetails.partnerPrice,
      msrp: patchedDetails.retailPrice,
      replacementMfc: patchedDetails.replacementMfc,
      replacementPart: patchedDetails.replacementPart,
      warehouseCode:
        wDefault !== -1
          ? patchedDetails.warehouses[wDefault].warehouseCode
          : null,
      warehouseQty:
        wDefault !== -1 ? patchedDetails.warehouses[wDefault].quantity : null,
      warehouseDesc:
        wDefault !== -1
          ? patchedDetails.warehouses[wDefault].description
          : null,
      inStock: patchedDetails.inStock,
      state: patchedDetails.state,
      stateDescription: patchedDetails.stateDescription,
      supplierQuantity:
        this.props.activePart !== null
          ? patchedDetails.warehouses[supply].quantity
          : 'N/A',
      extraProducts: details.extraProducts,
      extraTotalAmount: patchedDetails.extraTotalAmount,
      manufacturerCode: patchedDetails.manufacturerCode,
      replacedMfc: patchedDetails.replacedMfc,
      replacedPart: patchedDetails.replacedPart,
      specialOrder: patchedDetails.specialOrder,
      locations: patchedDetails.locations,
      warehouses: patchedDetails.warehouses
    };
  };

  private isMobile = (): boolean => {
    return window.innerWidth <= breakpoints.medium;
  };

  private handleWindowSizeChange = () => {
    const isMobile = !isMd();
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  };

  private handleModalStatus = (modalStatus: boolean) => {
    if (modalStatus) {
      this.setState({ isModalOpened: modalStatus });
      disableScroll();
    } else {
      this.setState({ isModalOpened: modalStatus });
      enableScroll();
    }
  };

  private scrollToPartsCatalog() {
    const offsetValue = this.state.isMobile ? -48 : -80;
    const scrollConfig = {
      offset: offsetValue,
      align: 'top',
      duration: 500
    };
    scrollToComponent(this.catalogRef, scrollConfig);
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }
  

  public componentDidUpdate(prevProps: IPartsCatalogProps) {
    const elements = document.querySelectorAll(
      '.rp-parts-catalog--active-diagram.modal-is-closed'
    );
    Stickyfill.add(elements);
    if (
      this.props.activeDiagram &&
      prevProps.activeDiagram !== this.props.activeDiagram
    ) {
      this.scrollToPartsCatalog();
    }
    if (prevProps.parts !== this.props.parts) {
      const products: Array<{
        productId: string;
        manufacturerCode: string;
        ownerDiagram: number;
      }> = [];
      this.props.parts.forEach(part => {
        if (part.productDetailsState === 'pending') {
          products.push({
            productId: part.productNumber,
            manufacturerCode: part.manufacturerCode,
            ownerDiagram: part.diagramOwner
          });
        }
      });
      let i: number = 0;
      for (i = 0; i < products.length; i = i + 10) {
        this.props.updateProductsMethod(products.slice(i, i + 10));
      }
    }
    if (prevProps.commonParts !== this.props.commonParts) {
      const products: Array<{
        productId: string;
        manufacturerCode: string;
        ownerDiagram: number;
      }> = [];
      this.props.commonParts.forEach(part => {
        if (part.productDetailsState === 'pending') {
          products.push({
            productId: part.productNumber,
            manufacturerCode: part.manufacturerCode,
            ownerDiagram: part.diagramOwner
          });
        }
      });
      let i: number = 0;
      for (i = 0; i < products.length; i = i + 10) {
        this.props.updateCommonPartsMethod(products.slice(i, i + 10));
      }
    }

    
    const nowInPartsMode = !!(this.props.useActiveDiagram || this.props.textFilter);
    const prevInPartsMode = !!(prevProps.useActiveDiagram || prevProps.textFilter);

     // when entering parts mode -> show loader
  if (nowInPartsMode && !prevInPartsMode && this.state.partsRendered) {
    this.setState({ partsRendered: false });
    return;
  }

     // if in parts mode and all parts are ready -> hide loader
  if (nowInPartsMode && !this.state.partsRendered && this.arePartsReady(this.props.parts)) {
    this.setState({ partsRendered: true });
    return;
  }

  // if parts become pending again (new diagram / new search results) -> show loader
  if (nowInPartsMode && this.state.partsRendered && !this.arePartsReady(this.props.parts)) {
    this.setState({ partsRendered: false });
    return;
  }
  }

  public componentDidMount() {
    const products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }> = [];
    this.props.commonParts.forEach(part => {
      if (part.productDetailsState === 'pending') {
        products.push({
          productId: part.productNumber,
          manufacturerCode: part.manufacturerCode,
          ownerDiagram: part.diagramOwner
        });
      }
    });
    let i: number = 0;
    for (i = 0; i < products.length; i = i + 10) {
      this.props.updateCommonPartsMethod(products.slice(i, i + 10));
    }
  }

  public render() {
    return (
      <section className="rp-parts-catalog">
        {this.renderActiveDiagram()}
        {this.renderContent()}
      </section>
    );
  }
}
interface IPartsCatalogProps {
  isLoggedIn: boolean;
  onlyMsrp: boolean;
  parts: ProductModel[];
  commonParts: ProductModel[];
  emptyMessage?: string;
  loading: boolean;
  paginator?: any;
  useActiveDiagram: boolean;
  goToDiagram(diagramId: number): any;
  diagrams: DiagramModel[];
  activeDiagram: DiagramModel;
  activePart: ProductModel | null;
  featuredProducts: ProductModel[];
  handlePageChange?(event: any): any;
  updateProductMethod(
    productId: string,
    manufacturerCode: string,
    ownerDiagram: number
  ): any;
  setActivePart(part: ProductModel | null): void;
  handleToggleFavorite?(
    name: string,
    mfc: string,
    ownerDiagram: number,
    favorite: boolean,
    favoriteId: number
  ): void;
  updateFeaturedProduct(productID: string, manufacturerCode: string): any;
  updateProductsMethod(
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ): any;
  updateCommonPartsMethod(
    products: Array<{
      productId: string;
      manufacturerCode: string;
      ownerDiagram: number;
    }>
  ): any;
  textFilter: string;
  modelDiagramProductClick(data: any): void;
}

interface IPartsCatalogState {
  isMobile: boolean;
  isModalOpened: boolean;
  partsRendered: boolean;
}
